import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { environment } from '@environments/environment';
import { debounce, delay } from 'lodash';


@Injectable({ providedIn: 'root' })
export class BlockProductCarouselNewService {
    private carouselHeadersSubject: BehaviorSubject<any>;
    public carouselHeaders: Observable<any>;

    private carouselProductsSubject: BehaviorSubject<any>;
    public carouselProducts: Observable<any>;

    private selectedHeaderSubject: BehaviorSubject<any>;
    public selectedHeader: Observable<any>;

    public loading = false;

    constructor(private http: HttpClient) {
        this.carouselHeadersSubject = new BehaviorSubject<any>([]);
        this.carouselHeaders = this.carouselHeadersSubject.asObservable();

        this.carouselProductsSubject = new BehaviorSubject<any>([]);
        this.carouselProducts = this.carouselProductsSubject.asObservable();

        this.selectedHeaderSubject = new BehaviorSubject<any>(null);
        this.selectedHeader = this.selectedHeaderSubject.asObservable();
    }

    public get carouselHeadersValue(): any {
        return this.carouselHeadersSubject.value;
    }

    public changeHeaders(headers){
        this.carouselHeadersSubject.next(headers);
    }

    public get carouselProductsValue(): any {
        return this.carouselProductsSubject.value;
    }

    public changeProducts(products: any[]){
        this.carouselProductsSubject.next(products);
    }

    public getCarouselProducts(params){
        //return this.http.get<any>(`${environment.apiUrl}/components`, { params: params });

    }

    public get selectedHeaderValue(): any {
        return this.selectedHeaderSubject.value;
    }

    public setLoading(state: boolean){
        this.loading = state;
    }

    public changeSelectedHeader(header){
        this.loading = true;
        this.selectedHeaderSubject.next(header);
        /// get new header products
        /// console.log("header selected: "+ JSON.stringify(header));
        delay(()=>{
            this.loading = false;
        }, 0);

    }

}
